/* eslint-disable */
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Axios from "axios";
import Spinner from "../../../components/Spinner/Spinner";
import withErrorHandler from "../../../hoc/withErrorHandler/withErrorHandler";
import * as actions from "../../../store/actions/index";

class AttributesTable extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleValueAdd = this.handleValueAdd.bind(this);
    this.handleAttributeDelete = this.handleAttributeDelete.bind(this);
    this.handleAttributeNameRename = this.handleAttributeNameRename.bind(this);
    this.handleValueNameRename = this.handleValueNameRename.bind(this);
    this.handleValueDelete = this.handleValueDelete.bind(this);

    this.state = {
      newValueName: "",
      newAttributeName: "",
      updatedValueName: "",
      attribute: null,
      attributes: null,
      untouchedservices: null,
    };
  }

  componentDidMount() {
    this.props.onFetchAttribute();
  }

  componentDidUpdate = () => {
    if (this.props.attributes != this.state.attributes) {
      this.setState({ attributes: this.props.attributes });
    }
  };

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  }

  // handleAddProduct(e) {
  //   e.preventDefault();
  //   let id = e.target.id;
  //   let attributeName = e.target.name;
  //   this.props.history.push("./attributes/addProducts", {
  //     id: id,
  //     attributeName: attributeName,
  //   });
  // }

  handleValueAdd(e, attribute) {
    e.preventDefault();
    let newValueName = this.state.newValueName;
    if (newValueName == "") {
      alert("Please enter a valid new attribute name");
    } else {
      let newCategory = {
        id: attribute.id,
        newValueName: newValueName,
      };
      this.props.onAddValue(newCategory, attribute);
    }
  }

  handleAttributeDelete(e) {
    e.preventDefault();
    let id = e.target.id;
    this.props.onDeleteAttribute(id);
  }

  handleAttributeNameRename(e, id) {
    e.preventDefault();
    let newAttributeName = this.state.newAttributeName;
    if (newAttributeName == "") {
      alert("Please enter a valid new attribute name");
    } else {
      let editedCategoryName = {
        id,
        name: newAttributeName,
      };
      this.props.onAttributeRename(editedCategoryName);
    }
  }

  handleValueNameRename(e, attribute, subCategory, attributeValues) {
    e.preventDefault();
    let updatedValueName = this.state.updatedValueName;
    if (updatedValueName.trim() == e.target.name.trim()) {
      return alert("The Attribute Already Exists");
    }
    if (updatedValueName == "") {
      alert("Please enter a valid new attribute name");
    } else {
      let editedCategoryName = {
        id: attribute.id,
        oldSubCategoryName: subCategory,
        subCategoryName: updatedValueName,
      };

      this.props.onValueRename(editedCategoryName, attribute, attributeValues);
    }
  }

  handleValueDelete(e) {
    e.preventDefault();
    let id = e.target.id;
    let subCategoryName = e.target.name;
    this.props.onDeleteValue(id, subCategoryName);
  }

  // handleUpload = (e) => {
  //   let name = e.target.name;
  //   let attribute = { ...this.state.attribute };
  //   if (typeof attribute[name] == "string") {
  //     attribute[`prev${name}`] = attribute[name];
  //   }
  //   attribute[name] = e.target.files[0];
  //   this.setState({ attribute: attribute });
  // };

  // handleChargeType = (e) => {
  //   let chargeId = e.target.value;
  //   let chargeType = this.props.chargeTypes.filter(
  //     (charge) => charge.chargeId == chargeId
  //   )[0];
  //   let attribute = { ...this.state.attribute };
  //   attribute["serviceChargeType"] = chargeType;
  //   this.setState({ attribute });
  // };

  handleCategoryEdit = (e, id) => {
    // let { name, value } = e.target;
    // let attributes = this.state.attributes.concat();
    // let attribute = attributes.filter((obj) => obj.id === id)[0];
    // attribute[name] = value;
    // this.setState({ attributes ,attribute});
    let attribute = this.state.attribute;
    attribute[e.target.name] = e.target.value;
    this.setState({ attribute: attribute });
  };

  render() {
    let attributes = this.props.attributes;

    return (
      <table className="table table-striped table-sm table-responsive">
        <thead>
          <tr className="text-center">
            <th scope="col">#</th>
            <th scope="col">Attribute</th>
            <th scope="col">Values</th>
            <th scope="col">Value</th>
          </tr>
        </thead>
        {this.props.loading ? (
          <Spinner />
        ) : (
          <tbody>
            {attributes &&
              attributes.map((attribute, index) => (
                <tr key={attribute.id}>
                  <th scope="row">{index + 1}</th>
                  {/* ----------------------- Attribute Listing starts ----------------------- */}
                  <td>
                    <div className="btn-group">
                      <button
                        type="button"
                        className="btn btn-danger btn-sm dropdown-toggle p-1 px-2 m-0"
                        style={{
                          backgroundColor: "orange",
                        }}
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        {attribute.name}
                      </button>
                      <div className="dropdown-menu">
                        {/* <button
                          className="dropdown-item"
                          data-toggle="modal"
                          data-target={`#e${attribute.id}`}
                          onClick={() => this.setState({ attribute: attribute })}
                        >
                          Edit
                        </button> */}
                        <button
                          className="dropdown-item"
                          data-toggle="modal"
                          data-target={`#r${attribute.id}`}
                          onClick={() =>
                            this.setState({ attribute: attribute })
                          }
                        >
                          Rename
                        </button>

                        {/* {this.props.isAdmin ? ( */}
                        <button
                          className="dropdown-item"
                          data-toggle="modal"
                          data-target={`#d${attribute.id}`}
                        >
                          Delete
                        </button>
                        {/* ) : null} */}
                      </div>
                    </div>
                    {/* ----------------------- Attribute Rename Modal starts ----------------------- */}
                    <div
                      className="modal fade"
                      tabIndex="-1"
                      role="dialog"
                      id={`r${attribute.id}`}
                      aria-labelledby="exampleModalLabel1"
                      aria-hidden="true"
                    >
                      <div className="modal-dialog" role="document">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel1">
                              Currently: {attribute.name}
                            </h5>
                            <button
                              type="button"
                              className="close"
                              data-dismiss="modal"
                              aria-label="Close"
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div
                            className="modal-body"
                            onSubmit={(e) =>
                              this.handleAttributeNameRename(e, attribute.id)
                            }
                          >
                            <form className="form-inline">
                              <div className="form-group mx-sm-3 mb-2">
                                <input
                                  type="text"
                                  name="newAttributeName"
                                  className="form-control"
                                  id="inputCategoryName"
                                  placeholder="Update Attribute name"
                                  onChange={this.handleChange}
                                  required
                                />
                              </div>
                              <button
                                type="submit"
                                className="btn btn-success btn-sm mb-2"
                                id={attribute.id}
                                // onClick={this.handleAttributeNameRename}
                                disabled={this.props.editAttributeNameLoading}
                              >
                                {this.props.editAttributeNameLoading
                                  ? "Renaming"
                                  : "Save"}
                              </button>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* ----------------------- Attribute Rename Modal ends ----------------------- */}
                    {/* ----------------------- Attribute Delete Modal starts ----------------------- */}
                    <div
                      className="modal fade"
                      tabIndex="-1"
                      role="dialog"
                      id={`d${attribute.id}`}
                      aria-labelledby="exampleModalLabel"
                      aria-hidden="true"
                    >
                      <div className="modal-dialog" role="document">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                              Irreversible operation
                            </h5>
                            <button
                              type="button"
                              className="close"
                              data-dismiss="modal"
                              aria-label="Close"
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div className="modal-body">
                            <p>
                              Are you sure you want to delete '{attribute.name}'
                              attribute ?
                            </p>
                          </div>
                          <div className="modal-footer">
                            <button
                              type="button"
                              className="btn btn-secondary btn-sm"
                              style={{
                                backgroundColor: "red",
                              }}
                              id={attribute.id}
                              onClick={this.handleAttributeDelete}
                              disabled={this.props.delAttributeBtnLoading}
                            >
                              {this.props.delAttributeBtnLoading
                                ? "Deleting"
                                : "Delete"}
                            </button>
                            <button
                              type="button"
                              className="btn btn-warning btn-sm"
                              data-dismiss="modal"
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* ----------------------- Attribute Delete Modal ends ----------------------- */}
                  </td>
                  {/* ----------------------- Attribute listing ends ----------------------- */}
                  {/* ----------------------- SubCategory listing starts ----------------------- */}
                  <td>
                    {attribute.values &&
                      attribute.values.map((value, index) => (
                        <React.Fragment key={index}>
                          <div className="btn-group">
                            <button
                              type="button"
                              className="btn btn-primary btn-sm dropdown-toggle p-1 px-2 m-1"
                              style={{
                                backgroundColor: "black",
                              }}
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              {value}
                            </button>
                            <div className="dropdown-menu">
                              <button
                                className="dropdown-item"
                                data-toggle="modal"
                                data-target={`#cr${
                                  attribute.id + value.replace(/\s/g, "").trim()
                                }`}
                                name={value}
                              >
                                Rename
                              </button>
                              {/* {this.props.isAdmin ? ( */}
                              <button
                                className="dropdown-item"
                                data-toggle="modal"
                                data-target={`#cd${
                                  attribute.id + value.replace(/\s/g, "").trim()
                                }`}
                                name={value}
                              >
                                Delete
                              </button>
                              {/* ) : null} */}
                            </div>
                          </div>
                          {/* ----------------------- SubCategory Rename Modal starts ----------------------- */}
                          <div
                            className="modal fade"
                            tabIndex="-1"
                            role="dialog"
                            id={`cr${
                              attribute.id + value.replace(/\s/g, "").trim()
                            }`}
                            aria-labelledby="exampleModalLabel1"
                            aria-hidden="true"
                          >
                            <div className="modal-dialog" role="document">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h5
                                    className="modal-title"
                                    id="exampleModalLabel1"
                                  >
                                    Currently: {value}
                                  </h5>
                                  <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                  >
                                    <span aria-hidden="true">&times;</span>
                                  </button>
                                </div>
                                <div className="modal-body">
                                  <form
                                    className="form-inline"
                                    onSubmit={(e) =>
                                      this.handleValueNameRename(
                                        e,
                                        attribute,
                                        value,
                                        attribute.values
                                      )
                                    }
                                  >
                                    <div className="form-group mx-sm-3 mb-2">
                                      <input
                                        type="text"
                                        name="updatedValueName"
                                        className="form-control"
                                        id="inputSubCategoryName"
                                        placeholder="Update SubCategory name"
                                        onChange={this.handleChange}
                                        required
                                      />
                                    </div>
                                    <button
                                      type="submit"
                                      className="btn btn-success btn-sm mb-2"
                                      style={{
                                        backgroundColor: "green",
                                      }}
                                      id={attribute.id}
                                      name={value}
                                      // onClick={(e)=>this.handleValueNameRename(e,attribute)}
                                      disabled={this.props.editValueLoading}
                                    >
                                      {this.props.editValueLoading
                                        ? "Renaming"
                                        : "Save"}
                                    </button>
                                  </form>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* ----------------------- SubCategory Rename Modal ends ----------------------- */}
                          {/* ----------------------- SubCategory Delete Modal starts ----------------------- */}
                          <div
                            className="modal fade"
                            tabIndex="-1"
                            role="dialog"
                            id={`cd${
                              attribute.id + value.replace(/\s/g, "").trim()
                            }`}
                            aria-labelledby="exampleModalLabel"
                            aria-hidden="true"
                          >
                            <div className="modal-dialog" role="document">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h5
                                    className="modal-title"
                                    id="exampleModalLabel"
                                  >
                                    Irreversible operation
                                  </h5>
                                  <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                  >
                                    <span aria-hidden="true">&times;</span>
                                  </button>
                                </div>
                                <div className="modal-body">
                                  <p>
                                    Are you sure you want to delete '{value}'
                                    attribute ?
                                  </p>
                                </div>
                                <div className="modal-footer">
                                  <button
                                    type="button"
                                    className="btn btn-secondary btn-sm"
                                    style={{
                                      backgroundColor: "red",
                                    }}
                                    id={attribute.id}
                                    name={value}
                                    onClick={this.handleValueDelete}
                                    disabled={this.props.delValueBtnLoading}
                                  >
                                    {this.props.delValueBtnLoading
                                      ? "Deleting"
                                      : "Delete"}
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-warning btn-sm"
                                    data-dismiss="modal"
                                  >
                                    Cancel
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* ----------------------- SubCategory Delete Modal ends ----------------------- */}
                        </React.Fragment>
                      ))}
                  </td>
                  {/* ----------------------- SubCategory listing ends ----------------------- */}
                  {/* ----------------------- Add SubCategory starts ----------------------- */}
                  <td className="text-center">
                    <button
                      className="btn btn-primary btn-sm p-1 px-2 m-0"
                      style={{
                        backgroundColor: "brown",
                      }}
                      data-toggle="modal"
                      data-target={`#sca${attribute.id}`}
                    >
                      &#9547;
                    </button>
                    <div
                      className="modal fade"
                      id={`sca${attribute.id}`}
                      tabIndex="-1"
                      role="dialog"
                      aria-labelledby="exampleModalCenterTitle"
                      aria-hidden="true"
                    >
                      <div
                        className="modal-dialog modal-dialog-centered"
                        role="document"
                      >
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5
                              className="modal-title"
                              id="exampleModalLongTitle"
                            >
                              Add SubCategory for {attribute.name}
                            </h5>
                            <button
                              type="button"
                              className="close"
                              data-dismiss="modal"
                              aria-label="Close"
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div className="modal-body">
                            <form
                              className="form-inline"
                              onSubmit={(e) =>
                                this.handleValueAdd(e, attribute)
                              }
                            >
                              <div className="form-group mx-sm-3 mb-2">
                                <input
                                  type="text"
                                  name="newValueName"
                                  className="form-control"
                                  id="inputCategoryName"
                                  placeholder="Enter value name"
                                  onChange={this.handleChange}
                                  required
                                />
                              </div>
                              <button
                                type="submit"
                                className="btn btn-primary btn-sm mb-2"
                                style={{
                                  backgroundColor: "green",
                                }}
                                id={`${attribute.id}`}
                                // onClick={(e) =>
                                //   this.handleValueAdd(e, attribute)
                                // }
                                disabled={this.props.addValueBtnLoading}
                              >
                                {this.props.addValueBtnLoading
                                  ? "Saving"
                                  : "Add"}
                              </button>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                  {/* ----------------------- Add Attribute ends ----------------------- */}
                </tr>
              ))}
          </tbody>
        )}
      </table>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    attributes: state.attributes.attribute,
    loading: state.attributes.loading,
    addValueBtnLoading: state.attributes.addValueBtnLoading,
    delAttributeBtnLoading: state.attributes.delAttributeBtnLoading,
    editAttributeNameLoading: state.attributes.editAttributeNameLoading,
    editValueLoading: state.attributes.editValueLoading,
    delValueBtnLoading: state.attributes.delValueBtnLoading,
    // editCategoryBtnLoading: state.attributes.editCategoryBtnLoading,
    // chargeTypes: state.charges.chargesTypes,
    // isAdmin: state.auth.admin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onFetchAttribute: () => dispatch(actions.fetchAttribute()),
    // onEditCategory: (attribute) => dispatch(actions.onEditCategory(attribute)),
    onAddValue: (newSubCategory, attribute) =>
      dispatch(actions.onAddValue(newSubCategory, attribute)),
    onAttributeRename: (editedCategoryName) =>
      dispatch(actions.onAttributeRename(editedCategoryName)),
    onDeleteAttribute: (id) => dispatch(actions.onDeleteAttribute(id)),
    onValueRename: (editedSubCategoryName, attribute, attributeValues) =>
      dispatch(
        actions.onValueRename(editedSubCategoryName, attribute, attributeValues)
      ),
    onDeleteValue: (id, subCategoryName) =>
      dispatch(actions.onDeleteValue(id, subCategoryName)),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withErrorHandler(AttributesTable, Axios))
);
